import bigDecimal from 'js-big-decimal';

import { Account, AccountBSUDetails } from '../../../generated-types';
import { BsuDetails, BsuDisplay } from '../AccountViewTypes';

export default (
    bsuDetails: AccountBSUDetails | undefined,
    account: Account | undefined,
    showBsuDetails: boolean,
    displayYearlyOrTotal: BsuDisplay,
): BsuDetails | undefined => {
    if (!showBsuDetails) {
        return undefined;
    }
    const isUnderOneYearBeforeFullBsu =
        parseFloat(bigDecimal.subtract(bsuDetails?.maxAllowedDepositTotal, bsuDetails?.totalBalance)) <
        (bsuDetails?.maxAllowedDepositPerYear || 0);
    if (displayYearlyOrTotal === BsuDisplay.YEARLY) {
        return {
            balance: isUnderOneYearBeforeFullBsu
                ? account?.balance.accountingBalance || 0
                : bsuDetails?.depositedAmountThisYear || 0,
            maxAmountToSave: isUnderOneYearBeforeFullBsu
                ? bsuDetails?.maxAllowedDepositTotal || 0
                : bsuDetails?.maxAllowedDepositPerYear || 0,
            amountToSave: isUnderOneYearBeforeFullBsu
                ? parseFloat(bigDecimal.subtract(bsuDetails?.maxAllowedDepositTotal, bsuDetails?.totalDepositedAmount))
                : parseFloat(
                      bigDecimal.subtract(bsuDetails?.maxAllowedDepositPerYear, bsuDetails?.depositedAmountThisYear),
                  ),
            underOneYearBeforeFullBsu: isUnderOneYearBeforeFullBsu,
            maxedOutBsu: isUnderOneYearBeforeFullBsu
                ? account?.balance.accountingBalance === bsuDetails?.maxAllowedDepositTotal
                : bsuDetails?.maxAllowedDepositPerYear === bsuDetails?.depositedAmountThisYear,
        };
    }

    return {
        balance: account?.balance.accountingBalance ?? 0,
        maxAmountToSave: bsuDetails?.maxAllowedDepositTotal ?? 0,
        amountToSave: (bsuDetails?.maxAllowedDepositTotal || 0) - (bsuDetails?.totalDepositedAmount ?? 0),
        maxedOutBsu: bsuDetails?.maxAllowedDepositTotal === account?.balance.accountingBalance,
    };
};
